import { INDRAApiService } from "@ibe.services/api.indra.service";
import { INDRADateService } from "@ibe.services/date.indra.service";
import { HttpClient } from "@angular/common/http";
import { Subject } from "rxjs";
import { MOCK_STATUS, URL_BFM_AVAILABILITY_CALENDAR, MOCK_URL_AVAILABILITY_CALENDAR_RETURNS, URL_BFM_AVAILABILITY_CALENDAR_RETURNS, URL_BFM_AVAILABILITY_CALENDAR_LOWEST_MONTH_PRICE, CALENDAR_VAR_KEY_BEST_PRICE, CALENDAR_VAR_KEY_DEPARTURE_DATE, CALENDAR_VAR_KEY_RETURNS, CALENDAR_VAR_KEY_RETURN_DATE, MOCK_CALENDAR_LOWEST_MONTH_PRICE, MOCK_URL_AVAILABILITY_CALENDAR_JAN, MOCK_URL_AVAILABILITY_CALENDAR_FEB, MOCK_URL_AVAILABILITY_CALENDAR_MAR, MOCK_URL_AVAILABILITY_CALENDAR_APR, MOCK_URL_AVAILABILITY_CALENDAR_MAY, MOCK_URL_AVAILABILITY_CALENDAR_JUN, MOCK_URL_AVAILABILITY_CALENDAR_JUL, MOCK_URL_AVAILABILITY_CALENDAR_AUG, MOCK_URL_AVAILABILITY_CALENDAR_SEP, MOCK_URL_AVAILABILITY_CALENDAR_OCT, MOCK_URL_AVAILABILITY_CALENDAR_NOV, MOCK_URL_AVAILABILITY_CALENDAR_DEC, SESSION_VAR_KEY_MARKET, TRIP_TYPE_ROUND_TRIP_CODE, TRIP_TYPE_ONE_WAY_CODE, } from "@ibe.config";
import { INDRABookingAvailabilityBlankCalendar, } from "@ibe.models/calendar-price.indra.model.lib";
import { map } from "rxjs/operators";
import * as moment from "moment";
import { INDRACurrencyService } from "./currency.indra.service";
import { INDRACalendarMonthlyCost } from "@ibe.models/calendar-monthly-cost.indra.model";
import { Store } from "@ngrx/store";
import * as BookingStepsActions from "@ibe/store/actions/booking-steps.actions";
import * as i0 from "@angular/core";
import * as i1 from "./api.indra.service";
import * as i2 from "@angular/common/http";
import * as i3 from "./date.indra.service";
import * as i4 from "./currency.indra.service";
import * as i5 from "@ngrx/store";
var INDRACalendarPriceService = /** @class */ (function () {
    function INDRACalendarPriceService(api, http, dateService, currencyService, store) {
        this.api = api;
        this.http = http;
        this.dateService = dateService;
        this.currencyService = currencyService;
        this.store = store;
        this.calendarData = []; // this will store the calendar prices..
        this.outboundPriceInitialCall = true;
        this.inboundPriceInitialCall = true;
        this.monthlyLowestPrice$ = new Subject();
        this.outboundPriceFetchedMonths = [];
        this.hasError = false;
    }
    INDRACalendarPriceService.prototype.getAvailabilityCalendarOutboundPrice = function (params, isCash) {
        var _this = this;
        if (this.outboundPriceInitialCall) {
            // resets the calendardata to remove the stored inbound prices..
            this.OutboundCostPerDay = [];
            this.outboundPriceInitialCall = false;
        }
        if (MOCK_STATUS.AVAILABILITY_CALENDAR) {
            var mockURL = this.INDRA_getMockURLForOutboundPrice(params.month ? params.month : new Date().getMonth() + 1);
            // return this.http.get<INDRABFMBookingAvailabilityCalendarResponse>(MOCK_URL_AVAILABILITY_CALENDAR);
            return this.http
                .get(mockURL)
                .pipe(map(function (response) {
                _this.structureCalendarData(response, CALENDAR_VAR_KEY_BEST_PRICE, CALENDAR_VAR_KEY_DEPARTURE_DATE, isCash, params);
                return response;
            }));
        }
        else {
            return this.api
                .INDRA_post(URL_BFM_AVAILABILITY_CALENDAR, params)
                .pipe(map(function (response) {
                _this.structureCalendarData(response, CALENDAR_VAR_KEY_BEST_PRICE, CALENDAR_VAR_KEY_DEPARTURE_DATE, isCash, params);
                return response;
            }));
        }
    };
    INDRACalendarPriceService.prototype.getAvailabilityCalendarInboundPrice = function (params, isCash) {
        var _this = this;
        if (this.inboundPriceInitialCall) {
            // resets the calendardata to remove the stored outbound prices..
            this.InboundCostPerDay = [];
            this.inboundPriceInitialCall = false;
        }
        if (MOCK_STATUS.AVAILABILITY_CALENDAR_RETURNS) {
            // return this.http.get<INDRABFMBookingAvailabilityCalendarReturnsResponse>(MOCK_URL_AVAILABILITY_CALENDAR_RETURNS);
            return this.http
                .get(MOCK_URL_AVAILABILITY_CALENDAR_RETURNS)
                .pipe(map(function (response) {
                _this.structureCalendarData(response, CALENDAR_VAR_KEY_RETURNS, CALENDAR_VAR_KEY_RETURN_DATE, isCash);
                return response;
            }));
        }
        else {
            return this.api
                .INDRA_post(URL_BFM_AVAILABILITY_CALENDAR_RETURNS, params)
                .pipe(map(function (response) {
                _this.structureCalendarData(response, CALENDAR_VAR_KEY_RETURNS, CALENDAR_VAR_KEY_RETURN_DATE, isCash);
                return response;
            }));
        }
    };
    INDRACalendarPriceService.prototype.getMonthlyLowestPrice = function (params) {
        if (MOCK_STATUS.CALENDAR_LOWEST_MONTH_PRICE) {
            return this.http.get(MOCK_CALENDAR_LOWEST_MONTH_PRICE);
        }
        else {
            var urlParam = URL_BFM_AVAILABILITY_CALENDAR_LOWEST_MONTH_PRICE + "?marketCode=" + params.marketCode + "&origin=" + params.origin + "&destination=" + params.destination + "&tripType=" + params.tripType + "&paxType=" + params.paxType;
            // add payWithMiles and starAlliance parameters if supplied
            if (params.payWithMiles !== undefined || params.starAlliance !== undefined) {
                urlParam += "&payWithMiles=" + params.payWithMiles + "&starAlliance=" + params.starAlliance;
            }
            // add outbound param if supplied
            if (params.outbound) {
                urlParam += "&outbound=" + params.outbound;
            }
            return this.api.INDRA_get(urlParam);
        }
    };
    INDRACalendarPriceService.prototype.structureCalendarData = function (response, type, dateType, isCash, params) {
        var _this = this;
        // builds the calendar data with blank prices..
        var blankCostsPerDay = new INDRABookingAvailabilityBlankCalendar(this.dateService);
        if (dateType === CALENDAR_VAR_KEY_DEPARTURE_DATE) {
            this.OutboundCostPerDay.length === 0
                ? (this.calendarData = blankCostsPerDay.data)
                : (this.calendarData = this.OutboundCostPerDay);
        }
        else if (dateType === CALENDAR_VAR_KEY_RETURN_DATE) {
            this.calendarData = blankCostsPerDay.data;
        }
        // takes a deep copy to remove the store reference..
        var calendarDataArr = JSON.parse(JSON.stringify(this.calendarData));
        var priceUnit = isCash ? "cash" : "miles";
        if (response && response.data && response.data[type]) {
            // copies prices from the API response to the calendarData..
            response.data[type].forEach(function (priceItem) {
                // identifies the calendarData index for priceItem's date..
                var calendarDataIndex = _this.calendarData.findIndex(function (calendarDataItem) {
                    return _this.dateService.INDRA_formatDate(priceItem[dateType].toString(), "YYYY-MM-DD") === moment(calendarDataItem.date).format("YYYY-MM-DD");
                });
                // updates the prices on the calendarData using the retrieved index..
                if (calendarDataIndex > -1 && _this.calendarData[calendarDataIndex]) {
                    calendarDataArr[calendarDataIndex].no_flights = priceItem.noFlights;
                    calendarDataArr[calendarDataIndex].sold_out = priceItem.soldOut;
                    // only add amount property if it's still not added
                    if (!calendarDataArr[calendarDataIndex]["ammount"]) {
                        calendarDataArr[calendarDataIndex]["ammount"] = {
                            currency: _this.currencyService.INDRA_getCurrencySymbol(),
                        };
                        calendarDataArr[calendarDataIndex]["ammount"].currency.value = "";
                        calendarDataArr[calendarDataIndex]["ammount"].points = "";
                        // calendarDataArr[calendarDataIndex]['ammount'].minMax = { currency: {}, points: {} };
                    }
                    // load currency/points depending on selected price unit
                    if (isCash) {
                        calendarDataArr[calendarDataIndex]["ammount"].currency.value =
                            priceItem.bestTotalPrice
                                ? priceItem.bestTotalPrice
                                : priceItem.price
                                    ? priceItem.price
                                    : "";
                        // calendarDataArr[calendarDataIndex]['ammount'].minMax.currency.monthlyMaximum = priceItem.monthlyMaximum;
                        // calendarDataArr[calendarDataIndex]['ammount'].minMax.currency.monthlyMinimum = priceItem.monthlyMinimum;
                    }
                    else {
                        calendarDataArr[calendarDataIndex]["ammount"].points =
                            priceItem.bestTotalMiles
                                ? priceItem.bestTotalMiles
                                : priceItem.miles
                                    ? priceItem.miles
                                    : "";
                        calendarDataArr[calendarDataIndex].isStarAlliance =
                            priceItem.starAlliance;
                        // calendarDataArr[calendarDataIndex]['ammount'].minMax.points.monthlyMaximum = priceItem.monthlyMaximum;
                        // calendarDataArr[calendarDataIndex]['ammount'].minMax.points.monthlyMinimum = priceItem.monthlyMinimum;
                    }
                }
            });
        }
        // updates the calendarData prices stored on this service..
        this.calendarData = calendarDataArr;
        if (dateType === CALENDAR_VAR_KEY_DEPARTURE_DATE) {
            this.OutboundCostPerDay = this.calendarData;
            this.outboundPriceInitialCall = false;
            if (params.month === undefined) {
                this.calendarData.forEach(function (data) {
                    var _a;
                    var month = moment(data.date).parseZone().month() + 1;
                    var index = _this.outboundPriceFetchedMonths.findIndex(function (mos) { return mos.month === month; });
                    index > -1
                        ? (_this.outboundPriceFetchedMonths[index][priceUnit] = true)
                        : _this.outboundPriceFetchedMonths.push((_a = {
                                month: month
                            },
                            _a[priceUnit] = true,
                            _a));
                });
            }
        }
        else if (dateType === CALENDAR_VAR_KEY_RETURN_DATE) {
            this.InboundCostPerDay = this.calendarData;
            this.inboundPriceInitialCall = false;
        }
        // returns the updated calendarData prices..
        response.data = this.calendarData;
        return response;
    };
    INDRACalendarPriceService.prototype.INDRA_getMockURLForOutboundPrice = function (month) {
        switch (month) {
            case 1:
                return MOCK_URL_AVAILABILITY_CALENDAR_JAN;
            case 2:
                return MOCK_URL_AVAILABILITY_CALENDAR_FEB;
            case 3:
                return MOCK_URL_AVAILABILITY_CALENDAR_MAR;
            case 4:
                return MOCK_URL_AVAILABILITY_CALENDAR_APR;
            case 5:
                return MOCK_URL_AVAILABILITY_CALENDAR_MAY;
            case 6:
                return MOCK_URL_AVAILABILITY_CALENDAR_JUN;
            case 7:
                return MOCK_URL_AVAILABILITY_CALENDAR_JUL;
            case 8:
                return MOCK_URL_AVAILABILITY_CALENDAR_AUG;
            case 9:
                return MOCK_URL_AVAILABILITY_CALENDAR_SEP;
            case 10:
                return MOCK_URL_AVAILABILITY_CALENDAR_OCT;
            case 11:
                return MOCK_URL_AVAILABILITY_CALENDAR_NOV;
            case 12:
                return MOCK_URL_AVAILABILITY_CALENDAR_DEC;
        }
    };
    /**
     * Moved from select month modal component to here
     * Build month header for calendar > select month modal and graph
     */
    INDRACalendarPriceService.prototype.buildMonthlist = function (stepIndex) {
        var months = [];
        var currentMonth = moment();
        for (var i = 0; i < 12; i++) {
            var month = new INDRACalendarMonthlyCost(parseInt(currentMonth.format("M")), currentMonth.format("MMMM YYYY"));
            if (stepIndex !== undefined) {
                month.stepIndex = stepIndex;
            }
            months.push(month);
            currentMonth = currentMonth.add(1, "M");
        }
        return months;
    };
    /**
     * Moved from select month modal component to here
     * Build month header with prices for calendar > select month modal and graph
     */
    INDRACalendarPriceService.prototype.getMonthPrice = function (steps, routeType, boundIndex, isLoggedIn, priceUnit, paxType) {
        var _this = this;
        var months = this.buildMonthlist(boundIndex);
        this.monthlyLowestPrice$.next([]);
        var responseMonth = [];
        if (steps && steps.length > 0) {
            var boundStep = steps[boundIndex];
            var param = {
                marketCode: sessionStorage.getItem(SESSION_VAR_KEY_MARKET),
                origin: boundIndex === 0 ? boundStep.codeDeparture : boundStep.codeArrival,
                destination: boundIndex === 0 ? boundStep.codeArrival : boundStep.codeDeparture,
                tripType: routeType,
                paxType: paxType,
            };
            // validate if user is logged in
            if (isLoggedIn) {
                // if logged in, pass payWithMiles and starAlliance value of arrival to calendar price api
                var isCash = priceUnit === "cash" || !priceUnit ? true : false;
                param.payWithMiles = isCash
                    ? false
                    : boundIndex === 0
                        ? boundStep._arrival.tapRoute
                        : boundStep._departure.tapRoute;
                param.starAlliance = isCash
                    ? false
                    : boundIndex === 0
                        ? boundStep._arrival.starAllianceRoute
                        : boundStep._departure.starAllianceRoute;
            }
            // if inbound, add outbound date
            if (boundIndex === 1) {
                param.outbound = moment(steps[0].date).format("YYYY-MM-DD");
            }
            this.getMonthlyLowestPrice(param).subscribe(function (response) {
                if (response && response.monthlyLowestPrices) {
                    // update months object with prices
                    var monthsWithPrice_1 = response.monthlyLowestPrices.data;
                    if (monthsWithPrice_1 && monthsWithPrice_1.length > 0) {
                        var updatedMonthsObj_1 = [];
                        months.forEach(function (monthlyCost) {
                            var monthWithPrice = monthsWithPrice_1.filter(function (value) { return value.month === monthlyCost.month; });
                            monthlyCost.minCost.currency =
                                monthWithPrice &&
                                    monthWithPrice.length > 0 &&
                                    monthWithPrice[0].price
                                    ? monthWithPrice[0].price
                                    : null; // assign null if no price
                            updatedMonthsObj_1.push(monthlyCost);
                        });
                        responseMonth = updatedMonthsObj_1;
                    }
                    else {
                        responseMonth = months;
                    }
                }
                if (!responseMonth || responseMonth.length === 0) {
                    responseMonth = months; // set months with only labels (no prices)
                }
                _this.monthlyLowestPrice$.next(responseMonth);
            }, function (error) {
                _this.monthlyLowestPrice$.next(months);
            });
        }
        else {
            this.monthlyLowestPrice$.next(months); // set months with only labels (no prices)
        }
    };
    /**
     * Moved from dates page component to here
     * Build outbond monthly prices for calendar and graph
     */
    INDRACalendarPriceService.prototype.INDRA_getOutboundCosts = function (steps, routeType, currentStep, priceUnit, cabinClass, paxType, isLoggedIn, month, year) {
        var _this = this;
        var _a;
        var index = month !== undefined
            ? this.outboundPriceFetchedMonths.findIndex(function (mos) { return mos.month === month && mos[priceUnit]; })
            : this.outboundPriceFetchedMonths.findIndex(function (mos) { return mos[priceUnit]; });
        if (index === -1) {
            var outboundIndex = 0; // outbound index is always 0 for RT/OW..
            if (steps && steps.length > 0) {
                var outboundStep = steps[outboundIndex];
                var param = {
                    cabinClass: cabinClass,
                    destination: outboundStep.codeArrival,
                    market: sessionStorage.getItem(SESSION_VAR_KEY_MARKET),
                    origin: outboundStep.codeDeparture,
                    tripType: routeType,
                    paxType: paxType,
                    month: month,
                    year: year
                };
                // validate if user is logged in
                var isCash = priceUnit === "cash" || !priceUnit ? true : false;
                if (isLoggedIn) {
                    // if logged in, pass payWithMiles and starAlliance value of arrival to calendar price api
                    param.payWithMiles = !isCash;
                    param.starAlliance = outboundStep._arrival.tapRoute ? false : outboundStep._arrival.starAllianceRoute ? true : false;
                }
                if (month !== undefined) {
                    param.month = month;
                    index > -1
                        ? (this.outboundPriceFetchedMonths[index][priceUnit] = true)
                        : this.outboundPriceFetchedMonths.push((_a = {
                                month: month
                            },
                            _a[priceUnit] = true,
                            _a));
                    this.getAvailabilityCalendarOutboundPrice(param, isCash).subscribe(function (response) {
                        if (response && response.data) {
                            _this.INDRA_dispatchResult(response, currentStep, routeType);
                        }
                        else {
                            // this will create blank costs per day..
                            _this.INDRA_dispatchBlankCalendar(currentStep);
                        }
                    }, function (error) {
                        _this.INDRA_dispatchBlankCalendar(currentStep);
                    });
                }
                else
                    this.INDRA_dispatchBlankCalendar(currentStep);
            }
        }
    };
    /**
     * Moved from dates page component to here
     * Build inbound monthly prices for calendar and graph
     */
    INDRACalendarPriceService.prototype.INDRA_getInboundCosts = function (steps, routeType, currentStep, priceUnit, cabinClass, paxType, isLoggedIn) {
        var _this = this;
        var outboundIndex = 0; // outbound index is always 1 for RT/OW..
        var inboundIndex = 1; // inbound index is always 1 for RT/OW..
        if (steps && steps.length > 0) {
            var inboundStep = steps[inboundIndex];
            var outboundStep = steps[outboundIndex];
            var param = {
                cabinClass: cabinClass,
                destination: inboundStep.codeArrival,
                market: sessionStorage.getItem(SESSION_VAR_KEY_MARKET),
                origin: inboundStep.codeDeparture,
                tripType: routeType,
                departureDate: moment(outboundStep.date)
                    .parseZone()
                    .format("YYYY-MM-DD"),
                paxType: paxType,
            };
            // validate if user is logged in
            var isCash = priceUnit === "cash" || !priceUnit ? true : false;
            if (isLoggedIn) {
                // if logged in, pass payWithMiles and starAlliance value of arrival to calendar price api
                param.payWithMiles = !isCash;
                param.starAlliance = inboundStep._departure.tapRoute ? false : inboundStep._departure.starAllianceRoute ? true : false;
            }
            this.getAvailabilityCalendarInboundPrice(param, isCash).subscribe(function (response) {
                if (response && response.data /*  && response.status === '200' */) {
                    _this.INDRA_dispatchResult(response, currentStep, routeType);
                }
                else {
                    _this.INDRA_dispatchBlankCalendar(currentStep);
                }
            }, function (error) {
                _this.INDRA_dispatchBlankCalendar(currentStep);
            });
        }
    };
    /**
     * Moved from dates page component to here
     * Store outbond/inbound monthly prices for calendar and graph
     */
    INDRACalendarPriceService.prototype.INDRA_dispatchResult = function (calendarResponse, currentStep, routeType) {
        var allCostsPerDay = [];
        allCostsPerDay[currentStep] = calendarResponse.data;
        if (routeType == TRIP_TYPE_ROUND_TRIP_CODE) {
            if (this.OutboundCostPerDay)
                allCostsPerDay[0] = this.OutboundCostPerDay;
            if (this.InboundCostPerDay)
                allCostsPerDay[1] = this.InboundCostPerDay;
        }
        else if (routeType == TRIP_TYPE_ONE_WAY_CODE) {
            if (this.OutboundCostPerDay) {
                allCostsPerDay[0] = this.OutboundCostPerDay;
            }
        }
        this.store.dispatch(new BookingStepsActions.PutAllCostsPerDayAction(allCostsPerDay));
        this.costsPerDay = allCostsPerDay;
        this.hasError = false;
    };
    /**
     * Moved from dates page component to here
     * Empty calendar
     */
    INDRACalendarPriceService.prototype.INDRA_dispatchBlankCalendar = function (currentStep) {
        var allCostsPerDay = [];
        var blankCostsPerDay = new INDRABookingAvailabilityBlankCalendar(this.dateService);
        allCostsPerDay[currentStep] = blankCostsPerDay.data;
        this.store.dispatch(new BookingStepsActions.PutAllCostsPerDayAction(allCostsPerDay));
        this.costsPerDay = allCostsPerDay;
        this.hasError = true;
    };
    /**
     * Moved from dates page component to here
     * Reset calendar to fetch new prices when user backs to select different route
     */
    INDRACalendarPriceService.prototype.INDRA_resetCalendar = function () {
        this.outboundPriceFetchedMonths = [];
        this.outboundPriceInitialCall = true;
        this.inboundPriceInitialCall = true;
    };
    // empty stored costs when returning to search page and selecting new dates
    INDRACalendarPriceService.prototype.INDRA_emptyCosts = function () {
        this.OutboundCostPerDay = null;
        this.InboundCostPerDay = null;
        this.costsPerDay = [];
    };
    INDRACalendarPriceService.ngInjectableDef = i0.defineInjectable({ factory: function INDRACalendarPriceService_Factory() { return new INDRACalendarPriceService(i0.inject(i1.INDRAApiService), i0.inject(i2.HttpClient), i0.inject(i3.INDRADateService), i0.inject(i4.INDRACurrencyService), i0.inject(i5.Store)); }, token: INDRACalendarPriceService, providedIn: "root" });
    return INDRACalendarPriceService;
}());
export { INDRACalendarPriceService };
